module.exports = __webpack_public_path__ + "img/vk-hover.9a880f18.svg";